module.exports = new __parcel__URL__("os_button.7ee4596f.png").toString();